import { render, staticRenderFns } from "./hitchFeedback.vue?vue&type=template&id=7c5a1860&scoped=true&"
import script from "./hitchFeedback.vue?vue&type=script&lang=js&"
export * from "./hitchFeedback.vue?vue&type=script&lang=js&"
import style0 from "./hitchFeedback.vue?vue&type=style&index=0&id=7c5a1860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5a1860",
  null
  
)

export default component.exports